var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHouIllustrationShopAndDine = function SvgHouIllustrationShopAndDine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 300,
    fill: "none",
    viewBox: "0 0 500 300"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E5F3E2",
    d: "M350.017 89.031a74 74 0 0 0-2.313-3.663c-10.715-15.926-29.162-26.817-47.309-31.745a107 107 0 0 0-24.376-3.566c-53.945-1.827-75.408 40.787-93.231 51.785s-45.247 29.78-43.42 69.185 30.166 76.502 85.009 78.821c54.842 2.318 58.5-22.459 89.119-31.63 20.265-6.065 34.661-26.549 41.714-45.48 9.605-25.792 9.152-59.305-5.193-83.707"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#75787B",
    d: "M135.552 106.971h-3.075V247h3.075zM365.941 106.971h-3.355V247h3.355z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#76818C",
    d: "M158.199 86.566h-3.355V224.92h3.355zM343.855 86.566H340.5V224.92h3.355z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M140.788 102.419h-11.499L153.432 67h9.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#90CC85",
    d: "M152.283 102.419h-11.494L162.632 67h9.194z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M163.788 102.419h-11.499L171.832 67h9.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#90CC85",
    d: "M175.275 102.419h-11.494L181.025 67h9.194z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M186.781 102.419h-11.5L190.225 67h9.199z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#90CC85",
    d: "M198.275 102.419h-11.494L199.425 67h9.2z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M209.773 102.419h-11.5L208.623 67h9.194z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#90CC85",
    d: "M221.267 102.419h-11.494L217.818 67h9.199z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M232.765 102.419h-11.499L227.015 67h9.194z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#90CC85",
    d: "M244.26 102.419h-11.494L236.21 67h9.199z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M255.752 102.419h-11.494L245.408 67h9.194z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#90CC85",
    d: "M267.251 102.419h-11.5L254.602 67h9.199z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M278.748 102.419h-11.494L263.805 67h9.199z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#90CC85",
    d: "M290.244 102.419h-11.5L273 67h9.194z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M301.739 102.419h-11.494L282.195 67h9.2z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#90CC85",
    d: "M313.242 102.419h-11.5L291.398 67h9.194z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M324.729 102.419h-11.494L300.586 67h9.199z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#90CC85",
    d: "M336.232 102.419h-11.499L309.789 67h9.194z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M347.727 102.419h-11.494L318.984 67h9.2z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#90CC85",
    d: "M359.222 102.419h-11.499L328.18 67h9.199z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M370.72 102.419h-11.494L337.383 67h9.194z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F9FA",
    d: "M129.292 102.451h11.499v12.211a4.34 4.34 0 0 1-4.339 4.338h-2.831a4.338 4.338 0 0 1-4.34-4.338v-12.211z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#90CC85",
    d: "M140.792 102.451h11.494v12.211a4.34 4.34 0 0 1-4.339 4.338h-2.826a4.338 4.338 0 0 1-4.34-4.338v-12.211z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F9FA",
    d: "M152.284 102.451h11.5v12.211a4.34 4.34 0 0 1-4.34 4.338h-2.831a4.342 4.342 0 0 1-4.34-4.338v-12.211z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#90CC85",
    d: "M163.788 102.451h11.483v12.211a4.34 4.34 0 0 1-4.339 4.338h-2.843a4.34 4.34 0 0 1-4.339-4.338v-12.211z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F9FA",
    d: "M175.266 102.451h11.494v12.211a4.34 4.34 0 0 1-4.34 4.338h-2.815a4.34 4.34 0 0 1-4.339-4.338z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#90CC85",
    d: "M186.776 102.451h11.494v12.211a4.34 4.34 0 0 1-4.339 4.338h-2.826a4.34 4.34 0 0 1-4.339-4.338v-12.211z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F9FA",
    d: "M198.269 102.451h11.494v12.211a4.34 4.34 0 0 1-4.339 4.338h-2.842a4.338 4.338 0 0 1-4.34-4.338v-12.211z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#90CC85",
    d: "M209.769 102.451h11.494v12.211a4.34 4.34 0 0 1-4.339 4.338h-2.842a4.338 4.338 0 0 1-4.34-4.338v-12.211z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F9FA",
    d: "M221.264 102.451h11.499v12.211a4.34 4.34 0 0 1-4.339 4.338h-2.842a4.338 4.338 0 0 1-4.34-4.338v-12.211z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#90CC85",
    d: "M232.766 102.451h11.494v12.211a4.34 4.34 0 0 1-4.34 4.338h-2.815a4.34 4.34 0 0 1-4.339-4.338z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F9FA",
    d: "M244.261 102.451h11.494v12.211a4.34 4.34 0 0 1-4.339 4.338h-2.842a4.342 4.342 0 0 1-4.34-4.338v-12.211z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#90CC85",
    d: "M255.754 102.451h11.494v12.211a4.34 4.34 0 0 1-4.34 4.338h-2.842a4.34 4.34 0 0 1-4.339-4.338v-12.211z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F9FA",
    d: "M267.254 102.451h11.494v12.211a4.34 4.34 0 0 1-4.34 4.338h-2.842a4.34 4.34 0 0 1-4.339-4.338v-12.211z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#90CC85",
    d: "M278.748 102.451h11.515v12.211a4.34 4.34 0 0 1-4.339 4.338h-2.842a4.338 4.338 0 0 1-4.34-4.338v-12.211z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F9FA",
    d: "M290.261 102.451h11.494v12.211a4.34 4.34 0 0 1-4.339 4.338h-2.842a4.342 4.342 0 0 1-4.34-4.338v-12.211z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#90CC85",
    d: "M301.738 102.451h11.494v12.211a4.34 4.34 0 0 1-4.339 4.338h-2.843a4.34 4.34 0 0 1-4.339-4.338v-12.211z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F9FA",
    d: "M313.238 102.451h11.494v12.211a4.34 4.34 0 0 1-4.339 4.338h-2.843a4.34 4.34 0 0 1-4.339-4.338v-12.211z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#90CC85",
    d: "M324.73 102.451h11.494v12.211a4.34 4.34 0 0 1-4.339 4.338h-2.843a4.338 4.338 0 0 1-4.339-4.338v-12.211z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F9FA",
    d: "M336.23 102.451h11.494v12.211a4.34 4.34 0 0 1-4.339 4.338h-2.843a4.338 4.338 0 0 1-4.339-4.338v-12.211z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#90CC85",
    d: "M347.722 102.451h11.494v12.211a4.34 4.34 0 0 1-4.339 4.338h-2.842a4.338 4.338 0 0 1-4.34-4.338v-12.211z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7F9FA",
    d: "M359.222 102.451h11.494v12.211a4.34 4.34 0 0 1-4.339 4.338h-2.842a4.338 4.338 0 0 1-4.34-4.338v-12.211z"
  })));
};
export default SvgHouIllustrationShopAndDine;